<template>
    <div id="app">
        <canvas  id="myCanvas" ref="myCanvas" width="32" height="32" />
                                
        <!-- <v-btn @click="drawRect">Draw</v-btn>
        <v-btn @click="clearRect">Clear</v-btn> -->
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "rack-graphic",
        props: ['frame', 'frameno'],
        data () {
            return {
                pins : [ 
                    {val: false, mask: 1},
                    {val: false, mask: 2}, 
                    {val: false, mask: 4}, 
                    {val: false, mask: 8}, 
                    {val: false, mask: 16}, 
                    {val: false, mask: 32}, 
                    {val: false, mask: 64}, 
                    {val: false, mask: 128}, 
                    {val: false, mask: 256}, 
                    {val: false, mask: 512}   
                ],
                pinGraphics: [
                    { x: 125, y: 187.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},

                    { x: 100, y: 137.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 150, y: 137.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},

                    { x: 75, y: 87.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 125, y: 87.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 175, y: 87.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},

                    { x: 50, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 100, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 150, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 200, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                ],
            }
        },
        methods: {
            pinIsDown(i){
                console.log(`   Pin ${i} Mask: ${this.pins[i].mask} is in score: ${this.frame.first} = ${(this.pins[i].mask & ~this.frame.first)== this.pins[i].mask}`)
                return (this.pins[i].mask & ~this.frame.first) == this.pins[i].mask;                
            },
            pinIsDisabled(i){
                return false;
            },
            clearRect(){                
                this.canvas.clearRect(0, 0, 250, 250); 
            },
            drawRect() {
                //console.log(`Frame ${frame-no}`)
                this.canvas.clearRect(0, 0, 250, 250);                
                
                for(var i in this.pinGraphics){
                    let p = this.pinGraphics[i];                  
                    
                    //console.log(`Frame ${this.frameno} Score: ${this.frame.first} Pin ${i} is down: ${this.pinIsDown[i]}`)
                    let filledFirst = (this.pins[i].mask & ~this.frame.first) != this.pins[i].mask;
                    let filledSecond = (this.pins[i].mask & ~this.frame.second) != this.pins[i].mask;
                    console.log(`   Pin ${i} Mask: ${this.pins[i].mask} is in score: ${this.frame.first} = ${filledFirst}`)
                
                    this.canvas.beginPath();
                    this.canvas.arc(p.x, p.y, p.r, 0, 2 * Math.PI);                    
                    
                    if( filledFirst ){
                        this.canvas.fillStyle = '#000000';
                        this.canvas.fill();
                    }
                    else if( filledSecond ){
                        this.canvas.fillStyle = '#777777';
                        this.canvas.fill();
                    }
                    else {
                        this.canvas.fillStyle = null;
                        this.canvas.lineWidth = 4;
                        this.canvas.strokeStyle = '#003300';
                        this.canvas.stroke();
                    }
                    
                } 

            },
        },
        mounted() {
            this.canvas = this.$refs["myCanvas"].getContext('2d');
            this.canvas.scale(0.125, 0.125)
            this.drawRect();
        },
    }
</script>

<style scoped>
.v-btn {
    min-width: 150px;
}
</style>